<template>
    <div id="app">
        <rkm-notification />
      
        <component :is="layout">
            <router-view />
        </component>
    </div>
</template>

<script>
// Components.
import AdminLayout from './layouts/AdminLayout'
import LoginLayout from './layouts/LoginLayout'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: {
        AdminLayout,
        LoginLayout,
    },
    computed: {
        ...mapGetters(['getToken']),
        layout() {
            let layout = null
        
            if (this.$route.matched.some(route => route.meta.layout === 'login')) {
                layout = 'login-layout'
            }
            else if (this.$route.matched.some(route => route.meta.layout === 'admin')) {
                layout = 'admin-layout'
            }
            
            return layout
        },
    },
}
</script>

<style>
body {
    background: #EEEEEE !important;
}
</style>